export default {
  updateGuideList(state, data) {
    state.guideList = data;
  },
}
